import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import RevealField from '../../../components/RevealField'
import SectionWithTag from '../../../components/SectionWithTag'
import PaddingContext from '../../../utils/PaddingContext'

const id = 'page.applications.solutions'

const data = [
    'novel',
    'selectivity',
    'uptake',
    'immuno',
    'solubility',
    'activity',
    'stability',
    'binding',
    'expression',
    'tolerance',
    'aggregation',
    'inhibition',
]

const Solutions = () => {
    const { padding } = useContext(PaddingContext)

    return (
        <div className='bg-green-light relative'>
            <div className='py-12 md:py-30 relative'>
                <SectionWithTag
                    tag={{ id: `${id}.tag` }}
                    className='3xl:max-w-screen-2xl mx-auto'
                    padding={padding}
                >
                    <div className='flex md:flex-row flex-col items-center justify-between gap-y-8 md:gap-y-0 justify-between py-9 md:pt-0 md:pb-20'>
                        <div className='md:max-w-[560px]'>
                            <FormattedMessage id={id} tagName='h2' />
                        </div>
                        <div className='md:max-w-[410px]'>
                            <FormattedMessage id={`${id}.description`} tagName='p' />
                        </div>
                    </div>
                </SectionWithTag>
                <div
                    className='grid grid-cols-2 md:grid-cols-6 gap-2 md:gap-5 side-padding 3xl:max-w-screen-2xl mx-auto'
                    style={{ ...padding }}
                >
                    {data.map((field) => (
                        <RevealField
                            key={field}
                            text={`page.applications.solutions.tags.${field}`}
                            image={`app-${field}`}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Solutions
